(function () {
  'use strict';
  if (window.__glConsultTrackingInstalled) return;
  window.__glConsultTrackingInstalled = true;
  var production = 'https://book-a-consult-production.up.railway.app';
  var pilot = 'https://book-a-consult-servicify-production.up.railway.app';
  var measurementId = 'G-W39PMKJ3CQ';
  var names = ['consult_start', 'consult_type_selected', 'consult_slot_selected', 'consult_form_start', 'consult_submit', 'consult_error'];
  var seen = new Set();
  var started = false;
  var completed = false;
  var privacy = function () { return window.GLConsultPrivacy; };
  function consent() { return privacy() ? privacy().read() : { version: 1, source: 'shopify_customer_privacy', analytics: false, marketing: false, saleOfData: false }; }
  function frame() { return document.getElementById('goldylost-booking'); }
  function frameOrigin(iframe) { try { var origin = new URL(iframe.src).origin; return origin === production || origin === pilot ? origin : ''; } catch (_) { return ''; } }
  function metaAllowed() { var c = consent(); return c.marketing && c.saleOfData; }
  function cookie(name) {
    if (!metaAllowed()) return '';
    try { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (_) { return ''; }
  }
  function attribution() { return privacy() ? privacy().attribution() : {}; }
  function sendContext() {
    var iframe = frame();
    if (!iframe || frameOrigin(iframe) !== production || !iframe.contentWindow) return;
    var c = consent();
    var permitted = c.marketing && c.saleOfData;
    var touch = permitted ? attribution() : {};
    var last = touch.last || {};
    var fbc = cookie('_fbc');
    if (!fbc && last.fbclid) fbc = 'fb.1.' + (last.ts || Date.now()) + '.' + last.fbclid;
    iframe.contentWindow.postMessage({
      type: 'goldylost-booking-context', schemaVersion: 1, consent: c,
      bookingPageUrl: location.origin + location.pathname,
      metaIds: permitted ? {
        fbp: cookie('_fbp'), fbc: fbc, gclid: last.gclid || '',
        externalId: window.SHOP_CUSTOMER_ID || '', city: window.SHOP_CUSTOMER_CITY || '',
        state: window.SHOP_CUSTOMER_STATE || '', zip: window.SHOP_CUSTOMER_ZIP || '', country: window.SHOP_CUSTOMER_COUNTRY || ''
      } : {},
      attribution: permitted ? {
        utmSource: last.utm_source || '', utmMedium: last.utm_medium || '', utmCampaign: last.utm_campaign || '', utmContent: last.utm_content || '',
        campaignId: last.campaign_id || '', adsetId: last.adset_id || '', adId: last.ad_id || '', landingPage: last.landing_page ? location.origin + last.landing_page : '',
        firstTouchDate: touch.first && touch.first.ts ? new Date(touch.first.ts).toISOString().slice(0, 10) : ''
      } : {}
    }, production);
  }
  function ga4(name, params) {
    if (!consent().analytics || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', name, Object.assign({ send_to: measurementId, consult_store: location.hostname === 'goldylost-miami.myshopify.com' ? 'miami' : 'sydney', transport_type: 'beacon' }, params));
      return true;
    } catch (_) { return false; }
  }
  function safeParams(params) {
    var result = {};
    if (!params || typeof params !== 'object') return result;
    if (/^[1-9]\d{0,15}$/.test(String(params.appointment_type_id || ''))) result.appointment_type_id = String(params.appointment_type_id);
    if (['online', 'in_person', 'unknown'].includes(params.appointment_mode)) result.appointment_mode = params.appointment_mode;
    if (['online', 'sydney', 'miami', 'berlin', 'unknown'].includes(params.consult_location)) result.consult_location = params.consult_location;
    if (['types', 'availability', 'validation', 'booking'].includes(params.error_stage)) result.error_stage = params.error_stage;
    if (['network', 'validation', 'rate_limit', 'server', 'unavailable', 'unknown'].includes(params.error_code)) result.error_code = params.error_code;
    return result;
  }
  function first(channel, id, storageAllowed) {
    var key = channel + ':' + id;
    if (seen.has(key)) return false;
    seen.add(key);
    if (!storageAllowed) return true;
    try {
      var storageKey = 'gl_consult_' + channel;
      var list = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      list = Array.isArray(list) ? list.filter(function (x) { return x && typeof x.id === 'string' && Date.now() - x.ts < 7 * 86400000; }).slice(-99) : [];
      if (list.some(function (x) { return x.id === id; })) return false;
      list.push({ id: id, ts: Date.now() });
      sessionStorage.setItem(storageKey, JSON.stringify(list));
    } catch (_) {}
    return true;
  }
  function complete(data) {
    var id = String(data.appointmentId || '');
    if (!/^[1-9]\d{0,15}$/.test(id) || data.schemaVersion !== 1) return;
    completed = true;
    var c = consent();
    var params = safeParams({ appointment_type_id: data.appointmentTypeId, appointment_mode: data.appointmentMode, consult_location: data.consultLocation });
    var mode = params.appointment_mode || 'unknown';
    var place = params.consult_location || 'unknown';
    var labels = { online: 'Online', sydney: 'Sydney', miami: 'Miami', berlin: 'Berlin', unknown: 'Unknown' };
    var calendarPlace = ['sydney', 'miami', 'berlin', 'unknown'].includes(data.actualCalendarLocation) ? data.actualCalendarLocation : place;
    var payload = Object.assign({ appointment_id: id, appointment_type: mode === 'online' ? 'Video consultation' : mode === 'in_person' ? 'In-person consultation' : 'Consultation', calendar: labels[calendarPlace], page: location.pathname }, params);
    if (c.analytics && typeof window.gtag === 'function' && first('ga4', id, true)) {
      var last = c.marketing && c.saleOfData ? attribution().last || {} : {};
      ga4('generate_lead', Object.assign({}, payload, { utm_campaign: last.utm_campaign || '', campaign_id: last.campaign_id || '', adset_id: last.adset_id || '', ad_id: last.ad_id || '' }));
    } else if (!c.analytics) first('ga4', id, false);
    if (metaAllowed() && typeof window.fbq === 'function' && first('meta', id, true)) {
      try { window.fbq('track', 'Schedule', { content_name: 'Free consultation', content_category: 'Consultation' }, { eventID: 'book-a-consult-' + id }); } catch (_) {}
    } else if (!metaAllowed()) first('meta', id, false);
    if ((c.analytics || metaAllowed()) && first('publish', id, c.analytics)) {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        try {
          var result = Shopify.analytics.publish('goldylost:consult_booked', Object.assign({}, payload, { trackingConsent: c }));
          if (result && typeof result.catch === 'function') result.catch(function () {});
        } catch (_) {}
      }
      window.dispatchEvent(new CustomEvent('gl:consult_booked', { detail: payload }));
    }
  }
  window.addEventListener('message', function (event) {
    var iframe = frame();
    if (!iframe || event.source !== iframe.contentWindow || event.origin !== frameOrigin(iframe)) return;
    var data = event.data;
    if (!data || typeof data !== 'object') return;
    if (data.type === 'goldylost-booking-height') {
      var height = Number(data.height);
      if (Number.isFinite(height) && height >= 200 && height <= 10000) iframe.style.height = Math.round(height) + 'px';
      sendContext();
    }
    if (data.type === 'goldylost-booking-scroll') {
      var rect = iframe.getBoundingClientRect();
      var offset = Number(data.offset);
      offset = Number.isFinite(offset) ? Math.min(10000, Math.max(0, offset)) : 0;
      window.scrollTo({ top: Math.max(window.scrollY + rect.top + offset - 25, 0), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (frameOrigin(iframe) !== production) return;
    if (data.type === 'goldylost-booking-ready' && data.schemaVersion === 1) sendContext();
    if (data.type === 'goldylost-booking-event' && data.schemaVersion === 1 && names.includes(data.eventName)) {
      if (data.eventName === 'consult_start') started = true;
      if (['consult_start', 'consult_form_start'].includes(data.eventName) && !first('funnel', data.eventName, false)) return;
      ga4(data.eventName, safeParams(data.params));
    }
    if (data.type === 'goldylost-booking-complete') complete(data);
  });
  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;
    var url;
    try { url = new URL(anchor.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/book-a-consult-wigs-toppers\/?$/i.test(url.pathname)) return;
    var section = anchor.closest('header') ? 'header' : anchor.closest('cart-drawer') ? 'cart' : location.pathname.includes('/products/') ? 'product' : 'page';
    ga4('consult_click', { consult_entry_context: section });
  });
  window.addEventListener('pagehide', function () { if (started && !completed) ga4('consult_exit', { consult_exit_stage: 'before_confirmation' }); });
  document.addEventListener('gl:privacy_changed', function () {
    var c = consent();
    if (!c.analytics) { try { sessionStorage.removeItem('gl_consult_ga4'); sessionStorage.removeItem('gl_consult_publish'); } catch (_) {} }
    if (!metaAllowed()) { try { sessionStorage.removeItem('gl_consult_meta'); } catch (_) {} }
    sendContext();
  });
  if (frame()) frame().addEventListener('load', sendContext);
  sendContext();
})();
